import { NgModule } from '@angular/core';

import { ProjectCardComponent } from './project-card.component';
import { CommonModule } from '@angular/common';
import { ProjectCardDataModule } from './project-card-data/project-card-data.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, ProjectCardDataModule, TranslateModule ],
  exports: [ProjectCardComponent],
  declarations: [ProjectCardComponent],
  providers: [],
})
export class ProjectCardModule {}
